module.exports = __webpack_public_path__ + "img/3.ab1f7d4c.png";